import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import IconExpandLess from '@mui/icons-material/ExpandLess';
import IconExpandMore from '@mui/icons-material/ExpandMore';
import Button from '../Button';
import Typography from '../Typography';
import { useTranslation } from '../../hooks/i18n';
import { Language } from '../../services/types';

type Props = {
  currentLanguage: Language;
  onChange: (lang: Language) => void;
};

const LanguageSelector = ({ currentLanguage, onChange }: Props) => {
  const { t } = useTranslation(['common']);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const LANGUAGE_OPTIONS: { code: Language; label: string }[] = [
    { code: Language.EN, label: t('common:languages.en') },
    { code: Language.ES, label: t('common:languages.es') },
  ];

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const currentLabel =
    LANGUAGE_OPTIONS.find((opt) => opt.code === currentLanguage)?.label ?? t('common:languages.en');

  return (
    <>
      <Button
        variant="text"
        onClick={handleOpen}
        endIcon={anchorEl ? <IconExpandLess /> : <IconExpandMore />}
        sx={{
          paddingLeft: '0px',
          marginRight: '8px',
          textTransform: 'capitalize',
          '&:hover': { backgroundColor: 'transparent' },
        }}
      >
        {currentLabel}
      </Button>
      <Menu
        sx={{ mt: '45px' }}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {LANGUAGE_OPTIONS.map((option) => (
          <MenuItem
            key={option.code}
            onClick={() => {
              onChange(option.code);
              handleClose();
            }}
          >
            <Radio
              checked={option.code === currentLanguage}
              value={option.code}
              name="language"
              inputProps={{ 'aria-label': option.label }}
            />
            <Typography textAlign="center">{option.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
